import { AccordionV2 } from "@components";

import { Media } from "../../Media";

export function ProductOptions({
  items,
  desktopState,
  mobileState,
}: {
  items: (
    | {
        id: string;
        analyticsTitle: string;
        title: string;
        children: JSX.Element;
      }
    | {
        id: string;
        title: string;
        children: JSX.Element;
      }
  )[];
  desktopState: [string[], React.Dispatch<React.SetStateAction<string[]>>];
  mobileState: [string[], React.Dispatch<React.SetStateAction<string[]>>];
}) {
  return (
    <>
      <Media greaterThanOrEqual="lg">
        <AccordionV2
          name="productOptions"
          trackInteraction
          collapsible
          animated
          state={desktopState}
          items={items}
        />
      </Media>

      <Media lessThan="lg">
        <AccordionV2
          name="productOptions"
          trackInteraction
          multiple
          animated
          state={mobileState}
          items={items}
        />
      </Media>
    </>
  );
}
